/**
 * File version management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class VersionManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async listVersions(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/file/vector/version', { params });
  }

  async addComment(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/file/vector/comment', { data });
  }

  async removeVersion(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/file/vector/removeVersion', { data });
  }
}
